import { useEffect } from 'react';

import { useLogout } from './hooks';
import { LoaderFullScreen } from 'ui/components';

const Logout = () => {
  const { handleLogout } = useLogout();

  useEffect(handleLogout, []);

  return <LoaderFullScreen message="" />;
};

export default Logout;
